import { render, staticRenderFns } from "./SupportFooterDashboard.vue?vue&type=template&id=4e5ad907&scoped=true&"
import script from "./SupportFooterDashboard.vue?vue&type=script&lang=js&"
export * from "./SupportFooterDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SupportFooterDashboard.vue?vue&type=style&index=0&id=4e5ad907&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e5ad907",
  null
  
)

export default component.exports